import { Input } from "@mantine/core";
import { useField } from ".";
import { IFile, ImageUpload } from "../upload/image-upload";

type Props = {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
};

export function ImageField({ name, label, required, disabled }: Props) {
  const { value, error, onChange } = useField(name);

  return (
    <Input.Wrapper label={label} error={error} required={required}>
      <ImageUpload value={value} onChange={(file: IFile) => onChange(file.url)} error={error} disabled={disabled} />
    </Input.Wrapper>
  );
}
